import type { AnalyticsTableColumn } from '../analyticsModule/components/AnalyticsTable/AnalyticsTable.types'
import type { AnalyticsPrecision } from '../analyticsModule/types'
import { formatChartLabel } from '../pages/AnalyticsReport/hooks/utils/formartChartLabel'

type CreateChartXAxisFormatterParams = {
  columnType?: AnalyticsTableColumn['type']
  columnDecorator?: AnalyticsTableColumn['decorator']
  dateRange: [Date, Date]
  precision: AnalyticsPrecision
}

export const createChartXAxisFormatter = ({
  columnType = 'string',
  columnDecorator,
  dateRange,
  precision,
}: CreateChartXAxisFormatterParams) => {
  return (value: string) =>
    formatChartLabel({
      value,
      type: columnType,
      decorator: columnDecorator,
      dateRange,
      precision,
    })
}
